var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scanner-container"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}]},[_c('video',{ref:"scanner",attrs:{"poster":"data:image/gif,AAAA"}}),_vm._v(" "),_c('div',{staticClass:"overlay-element"}),_vm._v(" "),_c('div',{staticClass:"laser"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }